import React from "react";
import { Form, Input, Select } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel, BacktestType } from "@/features/backtest";
import { purchaseTypeMap } from "./constants";
import { useDispatch } from "react-redux";

export default () => {
  const dispatch = useDispatch();
  const purchaseTypes = useRootSelector(BacktestSel.availPurchaseTypes);
  const purchaseSize = useRootSelector(BacktestSel.purchaseSize);
  const purchaseType = useRootSelector(BacktestSel.purchaseType);

  const { Option } = Select;
  const selectAfter = (
    <Form.Item name={"purchaseType"} noStyle initialValue={purchaseType}>
      <Select
        style={{ width: "200px" }}
        onChange={e =>
          dispatch(
            BacktestAction.updateSetup({ purchase: { size: purchaseSize, type: e as BacktestType.PurchaseType } })
          )
        }
      >
        {purchaseTypes.map(e => (
          <Option key={e} value={e}>
            {purchaseTypeMap[e]}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    <Form.Item
      label="Purchase Size"
      name={"purchaseSize"}
      rules={[{ required: true, message: "Please enter purchase size!" }]}
      initialValue={purchaseSize}
    >
      <Input
        style={{ width: "93%" }}
        addonAfter={selectAfter}
        onChange={e =>
          dispatch(BacktestAction.updateSetup({ purchase: { size: parseInt(e.target.value), type: purchaseType } }))
        }
      />
    </Form.Item>
  );
};
